exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-icon[data-v-762256db] {\n  margin-top: 12px;\n}\n.datasheet-record-edit-mode-file-max-size[data-v-762256db] {\n  color: #bc7610;\n}\n", ""]);

// exports
